import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

/**
 * Avisa a la alerta flotante de monitoreo (15/10/2026) que vuelva a
 * preguntar: la llaman las pantallas que registran un corte (riesgos y
 * activos) y la bandeja de cambios al aceptar uno, para que el aviso se
 * quite en cuanto el monitoreo queda hecho y no hasta la siguiente vuelta.
 */
@Injectable({ providedIn: "root" })
export class AlertaMonitoreoService {
  private readonly pedidos = new Subject<void>();

  /** Cada vez que alguien pide volver a preguntar. */
  readonly refrescos: Observable<void> = this.pedidos.asObservable();

  refrescar(): void {
    this.pedidos.next();
  }
}
